import React from "react";
import CarouselDos from "react-gallery-carousel";
import "react-gallery-carousel/dist/index.css";

//Style
import "./AboutUsCounterSection.css";

//Data
import aboutUsCounterData from "../../json/AboutUsCounterData.json";

//Component
import CounterComponent from "../CounterComponent/CounterComponent";

const AboutUsCounterSection = () => {
  const elements = [];

  aboutUsCounterData &&
    aboutUsCounterData.data.map((counter) => {
      return elements.push(<CounterComponent info={counter} />);
    });

  return (
    <section className="about-us-counter-section">
      <div className="about-us-counter-subcontainer">
        <h1 className="auc-title">
          Tu Seguridad Es Lo Más Importante Para Nosotros
        </h1>
        <div className="auc-counter-info-container">
          {aboutUsCounterData.data.map((counter, i) => {
            return <CounterComponent key={i} info={counter} />;
          })}
        </div>
        <div className="auc-counter-info-container-mobile">
          <CarouselDos
            children={elements}
            style={{
              height: "100%",
              width: "100%",
              backgroundColor: "transparent",
            }}
            isAutoPlaying={true}
            hasDotButtons={false}
            hasLeftButton={false}
            hasRightButton={false}
            hasMediaButton={false}
            hasIndexBoard={false}
            hasThumbnails={false}
            hasSizeButton={false}
            transitionSpeed={0.1}
          />
        </div>
      </div>
    </section>
  );
};

export default AboutUsCounterSection;
